export default __webpack_public_path__ + "static/media/relaypay.b369e1ee.svg";